import { useQuery } from "@tanstack/react-query";
import { getGoalParams } from "../api/goals.api";
import { Goal } from "../types/goal-parameters";

export interface Filters {
  employeeId: number;
  month?: string;
  year?: string;
}

export const goalsQueryKeys = {
  all: ["hr-emp-goals"] as const,
  list: (employeeId: number, month?: string, year?: string) =>
    [...goalsQueryKeys.all, "list", employeeId, month, year] as const,
};

export const useGoals = (filters: Filters) => {
  return useQuery<Goal>({
    queryKey: goalsQueryKeys.list(
      filters.employeeId,
      filters.month,
      filters.year,
    ),
    queryFn: () => getGoalParams(filters),
    enabled: !!filters.employeeId,
    staleTime: 1000 * 60 * 60 * 2,
    gcTime: 1000 * 60 * 60 * 2,
  });
};
